@if (icon) {
<div class="-card-category-product-asset">
  <app-link [to]="to"><lucide-icon [name]="icon" class="card-category-icon"></lucide-icon></app-link>
</div>
}
<a [attr.href]="totype === 'card' ? (to ? to : null) : null" [target]="template === 'external' ? '_blank' : '_self'">
  <div class="card-product -title" [ngClass]="totype === 'card' ? '' : '-header-link'">
    <div class="-subtitle -fontDisplayThin">{{ subtitle }}</div>
    <div class="-title-card-category-product">
      @if (totype === 'title') {
      <app-link [to]="to"
        ><h3>{{ title }}</h3></app-link
      >
      } @if (totype === 'card') {
      <h3>{{ title }}</h3>
      } @if (indicators?.length) { @for (indicator of indicators; track indicator) {
      <app-indicator-chip-wrapper [indicator]="indicator"> </app-indicator-chip-wrapper>
      } }
    </div>
  </div>
  <ng-content></ng-content>
</a>
